import { createStore } from "vuex";
import user from "./modules/user.js";
import jobs from "./modules/jobs.js";
import profile from "./modules/profile.js";
import axiosInstance from "@/composables/axios-instance.js";

export default createStore({
  state: {
    isLoaded: false,
    statistics: {}
  },
  getters: {
    getStatistics(state) {
      return state.statistics;
    }
  },
  mutations: {
    setStatistics(state, data) {
      state.statistics = data;
    }
  },
  actions: {
    getStatisticsFromApi({ commit }) {
      axiosInstance.get("/job/statistics/")
        .then(response => {
          commit("setStatistics", response.data);
        }).catch(error => {
          console.error(error);
        })
    },
  },
  modules: {
    user,
    jobs,
    profile
  },
});
